const quickLinks = [
  { label: "截图大图库", href: "#gallery" },
  { label: "主题合集", href: "#collections" },
  { label: "更新动态", href: "#updates" },
  { label: "常见问题", href: "#faq" },
];

const themeLinks = ["暗网流出", "暗网截图", "隐藏网络", "暗网线索", "网络信息"];

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-background-300/60 bg-background-200">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-radar-line text-lg"></i>
              </span>
              <span className="text-lg font-bold text-foreground-950">黑网爆料</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              专题合集式浏览暗网流出物料，整理暗网截图、网络信息与隐藏线索，按主题分类归档，支持原始片段对照。更新快，找完整线索更快。
            </p>
          </div>

          <nav aria-label="快速入口">
            <h2 className="text-sm font-semibold text-foreground-950">快速入口</h2>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className="text-sm font-semibold text-foreground-950">主题分类</h2>
            <ul className="mt-4 flex flex-wrap gap-2">
              {themeLinks.map((theme) => (
                <li key={theme}>
                  <a
                    href="#gallery"
                    className="inline-block whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                  >
                    {theme}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-300/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-600">© 2026 黑网爆料 · 专题合集浏览</p>
          <p className="text-xs text-foreground-600">
            本站为静态展示，内容为线索索引整理，不提供真实文件传输。
          </p>
        </div>
      </div>
    </footer>
  );
}